import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../../../services/api.service';
import { Localized } from '../../../../objects';
import { BibleBookEditComponent } from '../bible-book-edit/bible-book-edit.component';
import { BibleBookService } from '../../services/bible-book.service'; 

@Component({
  selector: 'app-bible-book',
  templateUrl: './bible-book.component.html',
  styleUrls: ['./bible-book.component.css']
})
export class BibleBookComponent implements OnInit {

  public entities: BibleBook[];

    public isLoading = false;
    public bibleBookSections: BibleBookSection[];


    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService,
      private bibleBookServiceSvc: BibleBookService,
      private ref: ChangeDetectorRef
    ) { }


    ngOnInit() {
      this.loadEntities();
  

      this.bibleBookServiceSvc.loadSections().then(
        (data) => {
          this.bibleBookSections = data;
        }
      ).catch((err) => {
        alert("Error while getting the languages"); //TODO this is temp
        console.log(err);
      }
      )
    }

    private loadEntities() {
      this.isLoading = true;
      this.apiSvc.get("api/BibleBooks", null).subscribe(
        (data: BibleBook[]) => {
          this.entities = data;
          console.log(this.entities);

           this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
      );
  }

  public add() {
    var modal = this.dialog.open(BibleBookEditComponent);
    modal.componentInstance.bibleBookSections = this.bibleBookSections;
    modal.componentInstance.setModel(new BibleBook());

    modal.afterClosed().subscribe((savedItem: BibleBook) => {
      console.log("modal closed", savedItem);
      if (savedItem !== undefined) {
       // obj = savedItem;
       this.entities.push(savedItem);
      }

    });
  }

  public edit(obj: BibleBook) {

    //console.clear();

    var modal = this.dialog.open(BibleBookEditComponent);
    modal.componentInstance.bibleBookSections = this.bibleBookSections;
    modal.componentInstance.setModel(obj);

    modal.afterClosed().subscribe((savedItem: BibleBook) => {
      //console.clear();
      console.log("modal closed", savedItem);

      if (savedItem !== undefined) {
        this.updateScope(obj, savedItem);
      }

    //  this.ref.markForCheck();

    });

  }

  public updateScope(oldItem: BibleBook, newItem: BibleBook) {
     var existingItem = this.entities.find(s => s.Id === oldItem.Id);
     if (existingItem != null) {
      Object.assign(existingItem, newItem);
     } else {
       this.entities.push(newItem);
     }
  }

  public delete(lang) {
     alert("Delete obj");
     console.log(lang);
  }

}


export class BibleBook {
  Id: string;
  Localized: Localized[];
  Section: BibleBookSection;
  DisplayOrder: number;
  Comments: string;
  NumberOfChapters: number;
}

export class BibleBookSection {
  Id: string;
  Localized: Localized[];
}
